import React, {useCallback, useEffect} from 'react';
import {useAuthContext} from "../LauncherAuthContext";
import {Button, Form, message, Select, Typography} from "antd";
import {
    Account,
    NarratorProfileForm,
    fromNarratorProfileToForm,
    toNarrativeProfileFromForm,
    PlayerExperienceLevel
} from "../types";
import {useTranslation} from "react-i18next";
import {MultiGameSelector} from "../../common/MultiGameSelector";
import axios, {AxiosResponse} from "axios";
import {Label} from "../../../commons/translations/Label";

export const NarratorForm: React.FC<{closeModal: () => void}> = (props) => {
    const { closeModal } = props;
    const { user, isNarrator, updateAccount } = useAuthContext();
    const [form] = Form.useForm<NarratorProfileForm>();
    const { t} = useTranslation();

    useEffect(() => {
        if (isNarrator() && user?.narrator) {
            form.setFieldsValue(fromNarratorProfileToForm(user?.narrator));
        }
    }, [isNarrator, user, form]);

    const updateProfile = useCallback((data: NarratorProfileForm) => {
        if (!user) {
            return;
        }
        const profileDto = toNarrativeProfileFromForm(data);
        return axios.post<any, AxiosResponse<Account>>(`/api/launcher/users/account/${user.id}/narrator-profile`, profileDto)
            .then(r => r.data)
            .then((updated) => {
                message.success(t('profile.success.update'));
                updateAccount(updated);
                closeModal();
            })
            .catch(() => message.error(t('profile.error.update')));
    },[user, t, updateAccount, closeModal]);

    return (
        <>
            <Form form={form} onFinish={updateProfile} layout={"vertical"}>
                <Typography.Title level={3}><Label trl="profile.narrator.setup.prompt" /></Typography.Title>
                <Form.Item name={"experience"} label={<Label trl="profile.narrator.experience.label" />}>
                    <Select>
                        <Select.Option value={PlayerExperienceLevel.NEWBIE}>{t('experience.newbie')}</Select.Option>
                        <Select.Option value={PlayerExperienceLevel.BEGINNER}>{t('experience.beginner')}</Select.Option>
                        <Select.Option value={PlayerExperienceLevel.ADEPT}>{t('experience.adept')}</Select.Option>
                        <Select.Option value={PlayerExperienceLevel.MASTER}>{t('experience.master')}</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item name={"games"} label={<Label trl="profile.narrator.games.label" />}>
                    <MultiGameSelector />
                </Form.Item>
                <p>
                    <Button style={{width: '100%'}} size={"large"} type="primary" onClick={form.submit}><Label trl="common.save" /></Button>
                </p>
                <p>
                    <Button style={{width: '100%'}} size={"large"} type="primary" danger onClick={closeModal}><Label trl="common.cancel" /></Button>
                </p>
            </Form>
        </>
    );
}